import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.ebookpoint.shop/cart/59601048338513:1';
export function scrollToBuy() {
  const el = document.getElementById('comprar');
  if (el) el.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}
interface BuyButtonProps {
  label?: string;
  variant?: 'primary' | 'secondary';
  direct?: boolean;
  className?: string;
  pulse?: boolean;
}
export function BuyButton({
  label = 'QUIERO ACCEDER AHORA',
  variant = 'primary',
  direct = false,
  className = '',
  pulse = false
}: BuyButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-4 sm:py-5 rounded-xl font-extrabold text-base sm:text-lg uppercase tracking-wide transition-all duration-200 shadow-lg active:scale-[0.98]';
  const styles = variant === 'primary' ? 'bg-green-600 hover:bg-green-700 text-white shadow-green-600/30 hover:shadow-xl' : 'bg-white hover:bg-green-50 text-green-700 border-2 border-green-600';
  if (direct) {
    return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${styles} ${pulse ? 'pulse-soft' : ''} ${className}`} data-id="element-38">
        <ShoppingCartIcon className="w-5 h-5" data-id="element-39" />
        {label}
      </a>;
  }
  return <button onClick={scrollToBuy} className={`${base} ${styles} ${pulse ? 'pulse-soft' : ''} ${className}`} data-id="element-40">
      <ShoppingCartIcon className="w-5 h-5" data-id="element-41" />
      {label}
    </button>;
}
export { CHECKOUT_URL };